export default __webpack_public_path__ + "static/media/308.39997df9.png";